module.exports = __webpack_public_path__ + "static/media/Document.2436c99b.svg";